import { defineSlotRecipe } from "@pandacss/dev";

export const aromaListItem = defineSlotRecipe({
  className: "aroma-list-item",
  jsx: ["ListItem", "ListItemRoot", "ListItemChild"],
  slots: ["root", "item", "itemContent", "itemActions"],
  base: {
    root: {
      flexDirection: "column",
      gap: "gap.2",
    },
    item: {
      display: "flex",
      gap: "gap.4",
      borderRadius: "l",
      justifyContent: "space-between",
      border: "none",
      outlineWidth: "m",
      outlineStyle: "solid",
    },
    itemContent: {
      display: "flex",
      alignItems: "center",
    },
    itemActions: {
      display: "flex",
      alignItems: "center",
      gap: "gap.1",
    },
  },
  variants: {
    function: {
      neutral: {
        item: {
          outlineColor: "border.neutral.bold",
        },
      },
      warning: {
        item: {
          outlineColor: "border.functional.warning",
        },
      },
      error: {
        item: {
          outlineColor: "border.functional.error",
        },
      },
    },
    size: {
      small: {
        item: {
          paddingY: "padding.2",
          paddingLeft: "padding.4",
          paddingRight: "padding.2",
        },
        itemContent: {
          minHeight: "{sizes.m}",
        },
        itemActions: {
          maxHeight: "{sizes.m}",
        },
      },
      medium: {
        item: {
          padding: "padding.3",
          paddingLeft: "padding.4",
          paddingRight: "padding.3",
        },
        itemContent: {
          minHeight: "{sizes.xl}",
        },
        itemActions: {
          maxHeight: "{sizes.xl}",
        },
      },
    },
  },
  defaultVariants: {
    function: "neutral",
    size: "small",
  },
});
